import { ContactUsPage } from '@exploration/pages-contact-us';
import { getContactUsPageServerSideProps } from '@exploration/pages-contact-us/data';

export const getServerSideProps = getContactUsPageServerSideProps;

export default ContactUsPage;
